import React, {useState} from 'react';
import {staffApi} from '@/lib/staffApi';
import {formatMoney} from '@/lib/format';

export function BookingManagement({appointment, onSaved, onDeleted, onEditPrice}) {
    const [mode,setMode]=useState(null), [services,setServices]=useState([]), [serviceId,setServiceId]=useState('');
    const [busy,setBusy]=useState(false), [error,setError]=useState(''), [notice,setNotice]=useState('');
    const chosen=services.find(s=>String(s.id)===serviceId);
    const open=async()=>{
        setMode('edit');setError('');setServiceId(String(appointment.serviceId));setBusy(true);
        try {const r=await staffApi.services();setServices(r.services || []);}
        catch(e){setError(e.message || 'Could not load treatments.');}
        finally{setBusy(false);}
    };
    const save=async(remove=false)=>{
        if(busy)return;setBusy(true);setError('');
        const payload={expected_service_id:appointment.serviceId,expected_start:appointment.bookingStart};
        try{
            const result=remove ? await staffApi.deleteBooking(appointment.id,payload)
                : await staffApi.changeTreatment(appointment.id,{...payload,service_id:Number(serviceId)});
            setMode(null);
            if(remove)onDeleted();
            else {setNotice(result.warning || 'Treatment updated. Recorded payments are preserved. Check the deposit card and assigned forms before sending any new requests.');onSaved();}
        }catch(e){setError(e.message || 'The booking could not be updated. Please refresh.');}
        finally{setBusy(false);}
    };
    if(appointment.deleted)return <section className="rounded-2xl glass p-5">This booking was deleted from the diary. Its receipts and completed forms are retained.</section>;
    return <section className="rounded-2xl glass p-5 space-y-3" data-testid="booking-management">
        <h2 className="text-white font-semibold">Manage booking</h2>
        {notice && <p role="status" className="text-sm text-white/80">{notice}</p>}
        {error && <p role="alert" className="text-amber-200">{error}</p>}
        <div className="flex flex-wrap gap-3">
            {onEditPrice && <button type="button" disabled={busy} onClick={onEditPrice} className="rounded-full bg-gold text-navy px-4 py-2">Edit appointment price</button>}
            <button type="button" disabled={busy} onClick={open} className="rounded-full bg-gold text-navy px-4 py-2">Change treatment</button>
            <button type="button" disabled={busy} onClick={()=>{setMode('delete');setError('');}} className="rounded-full border border-red-300/50 text-red-200 px-4 py-2">Delete booking</button>
        </div>
        {mode==='edit' && <div className="space-y-3">
            <label className="block text-white">Treatment
                <select aria-label="Replacement treatment" disabled={busy} value={serviceId} onChange={e=>setServiceId(e.target.value)} className="block w-full mt-2 p-3 rounded-lg bg-white text-navy">
                    {services.map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
                </select>
            </label>
            {chosen && <p className="text-sm text-white/80">New price: {formatMoney(chosen.price)} · {Math.round(Number(chosen.duration || 0)/60)} minutes. Existing payments stay on this booking.</p>}
            {chosen && Number(appointment.payment?.amount || 0)>Number(chosen.price) && <p className="text-amber-200 text-sm">The recorded payment exceeds the new price. No refund will be made automatically.</p>}
            <div className="flex gap-3">
                <button disabled={busy || !chosen || Number(serviceId)===Number(appointment.serviceId)} onClick={()=>save()} className="rounded-full bg-gold text-navy px-4 py-2 disabled:opacity-40">{busy?'Saving…':'Save treatment'}</button>
                <button disabled={busy} onClick={()=>setMode(null)}>Cancel</button>
            </div>
        </div>}
        {mode==='delete' && <div role="alertdialog" aria-label="Delete booking confirmation" className="space-y-3 border-t border-white/20 pt-3">
            <p className="text-white">Delete this booking and free its time slot?</p>
            <p className="text-sm text-white/70">It will disappear from the calendar. Payment receipts and completed forms are retained. This does not refund payments or send a cancellation message.</p>
            <div className="flex gap-3">
                <button disabled={busy} onClick={()=>save(true)} className="rounded-full bg-red-700 text-white px-4 py-2">{busy?'Deleting…':'Confirm delete'}</button>
                <button disabled={busy} onClick={()=>setMode(null)}>Keep booking</button>
            </div>
        </div>}
    </section>;
}
